<template lang="pug">
.error
    BaseSheet(color="white" elevation="none").error-container
        .text-align-center
            p.description 大変申し訳ございません。
                br
                |該当ページがございません。

</template>

<script setup>
    import BaseSheet from '@/components/atoms/BaseSheet.vue'
    import { useHead } from '@unhead/vue'
    import { VueHelper } from '@/helpers/vue'

    useHead({
        title: '指定されたページが見つかりません'
    })

    VueHelper.unlock()

</script>

<style scoped lang="stylus">
    .error
        padding-bottom: 90%

    .error-container
        min-width 328px
        min-height 194px
        padding 50px 40px
        :deep(.button)
            min-width unset
            width 100%

    +tab-up()
        .error-container
            :deep(.button)
                min-width 286px
                width unset
</style>
